module.exports = window.slice.React;